import { render, staticRenderFns } from "./Tutorials.vue?vue&type=template&id=70afa3e3&scoped=true"
import script from "./Tutorials.vue?vue&type=script&lang=js"
export * from "./Tutorials.vue?vue&type=script&lang=js"
import style0 from "./Tutorials.vue?vue&type=style&index=0&id=70afa3e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70afa3e3",
  null
  
)

export default component.exports